import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { doGetLoggedInUserDetails } from "./reducer_core";

export const roleManagementSlide = createSlice({
    name: "roleManagement",
    initialState: {
        page: 0,
        pageCount: 0,
        totalRow: 0,
        success: false,
        fail: false,
        listData: null,
        detailData: null,
        responseData: null,
        errorDetailData: null,
        permissionCatalogue: null,
        permissionTotal: 0,
    },
    reducers: {
        doGetRoleManagementListSuccess: (state, action) => {
            state.listData = action.payload.data;
            state.page = action.payload?.current_page;
            state.pageCount = action.payload?.page_count;
            state.totalRow = action.payload?.total_row;
            state.permissionTotal = action.payload?.permission_total || 0;
        },
        doGetRoleManagementListFail: (state, action) => {
            state.listData = null;
            state.page = 0;
            state.pageCount = 0;
            state.totalRow = 0;
        },
        doGetPermissionCatalogueSuccess: (state, action) => {
            state.permissionCatalogue = action.payload?.data;
            state.permissionTotal = action.payload?.total || 0;
        },
        doGetPermissionCatalogueFail: (state, action) => {
            state.permissionCatalogue = null;
        },
        doGetRoleManagementDetailSuccess: (state, action) => {
            state.detailData = action.payload.data;
        },
        doGetRoleManagementDetailFail: (state, action) => {
            state.detailData = null;
        },
        doAddRoleManagementSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
            state.responseData = action.payload;
        },
        doAddRoleManagementFail: (state, action) => {
            state.success = false;
            state.fail = true;
            state.errorDetailData = action.payload;
        },
        doUpdateRoleManagementSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
        },
        doUpdateRoleManagementFail: (state, action) => {
            state.success = false;
            state.fail = true;
            state.errorDetailData = action.payload;
        },
        resetRoleManagementStateSuccess: (state, action) => {
            state.success = action.payload;
            state.fail = action.payload;
            state.detailData = null;
            state.errorDetailData = null;
        },
        resetRoleManagementErrorState: (state, action) => {
            state.success = false;
            state.fail = false;
            state.errorDetailData = null;
        },
    },
});

export const doGetRoleManagementList = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/role-management?page=${param.page}&size=${param.limit}`;
        if (param.filter) {
            url += `&filter=${encodeURIComponent(param.filter)}`;
        }
        const response = await axios.get(url);
        dispatch(doGetRoleManagementListSuccess(response.data));
    } catch (error) {
        dispatch(doGetRoleManagementListFail(error.response));
    }
};

// The checkbox matrix. Code-defined on the server, so this is the single source
// of truth for which permissions exist and what they are called.
export const doGetPermissionCatalogue = () => async (dispatch) => {
    try {
        const response = await axios.get(`/api/admin/role-management/permissions`);
        dispatch(doGetPermissionCatalogueSuccess(response.data));
    } catch (error) {
        dispatch(doGetPermissionCatalogueFail(error.response));
    }
};

export const doGetRoleManagementDetail = (param) => async (dispatch) => {
    try {
        const response = await axios.get(`/api/admin/role-management/${param.role_id}`);
        dispatch(doGetRoleManagementDetailSuccess(response.data));
    } catch (error) {
        dispatch(doGetRoleManagementDetailFail(error.response));
    }
};

export const doAddRoleManagement = (param) => async (dispatch) => {
    try {
        const response = await axios.post(`/api/admin/role-management`, param);
        dispatch(doAddRoleManagementSuccess(response.data));
    } catch (error) {
        dispatch(doAddRoleManagementFail(error.response));
    }
};

export const doUpdateRoleManagement = (param, role_id) => async (dispatch) => {
    try {
        const response = await axios.put(`/api/admin/role-management/${role_id}`, param);
        dispatch(doUpdateRoleManagementSuccess(response.data));
        // A permission change can affect the person who made it (they may hold a
        // different role that inherits nothing here, but a Super Admin editing
        // Admin often does). Re-reading identity keeps their own sidebar honest
        // without waiting for the next navigation.
        dispatch(doGetLoggedInUserDetails());
    } catch (error) {
        dispatch(doUpdateRoleManagementFail(error.response));
    }
};

export const doDeleteRoleManagement = (param) => async (dispatch) => {
    try {
        const response = await axios.delete(`/api/admin/role-management/${param.role_id}`);
        dispatch(doUpdateRoleManagementSuccess(response.data));
    } catch (error) {
        dispatch(doUpdateRoleManagementFail(error.response));
    }
};

export const resetRoleManagementState = () => async (dispatch) => {
    dispatch(resetRoleManagementStateSuccess(false));
};

export const {
    doGetRoleManagementListSuccess,
    doGetRoleManagementListFail,
    doGetPermissionCatalogueSuccess,
    doGetPermissionCatalogueFail,
    doGetRoleManagementDetailSuccess,
    doGetRoleManagementDetailFail,
    doAddRoleManagementSuccess,
    doAddRoleManagementFail,
    doUpdateRoleManagementSuccess,
    doUpdateRoleManagementFail,
    resetRoleManagementStateSuccess,
    resetRoleManagementErrorState,
} = roleManagementSlide.actions;

export const getRoleManagementList = (state) => state.roleManagement?.listData;
export const getRoleManagementListPage = (state) => state.roleManagement?.page;
export const getRoleManagementListPageCount = (state) => state.roleManagement?.pageCount;
export const getRoleManagementListTotal = (state) => state.roleManagement?.totalRow;
export const getRoleManagementDetail = (state) => state.roleManagement?.detailData;
export const getPermissionCatalogue = (state) => state.roleManagement?.permissionCatalogue;
export const getPermissionTotal = (state) => state.roleManagement?.permissionTotal;
export const getRoleManagementErrorDetailData = (state) => state.roleManagement?.errorDetailData;
export const getAddRoleManagementSuccess = (state) => state.roleManagement?.success;
export const getAddRoleManagementFail = (state) => state.roleManagement?.fail;

export default roleManagementSlide.reducer;
